<template>
  <Modal
    title="选择成员"
    v-model="visibleDialog"
    width="800px"
    transfer
    class="promoter_person"
    :mask-closable="false"
  >
    <personSelect
      v-if="visibleDialog"
      :list.sync="list"
      :multiple="multiple"
      :selectList.sync="selectList"
      :selectedIds.sync="selectedIds"
      :selectGroupIds.sync="selectGroupIds"
      :originData="originData"
      :customTreeList.sync="customTreeList"
    />
    <span slot="footer" class="dialog-footer">
      <Button @click="$emit('update:visible', false)">取 消</Button>
      <Button type="primary" @click="saveDialog">确 定</Button>
    </span>
  </Modal>
</template>

<script>
import { personSelect } from '@/components/personDepartmentRoleSelect';
import mixins from './mixins';
export default {
  components: { personSelect },
  mixins: [mixins],
  props: ['visible', 'multiple', 'selected'],
  watch: {
    visible(val) {
      this.visibleDialog = this.visible;
      if (val) {
        this.getDepartmentAndPersonList(this.selected);
      }
    },
    visibleDialog(val) {
      this.$emit('update:visible', val);
    }
  },
  computed: {},
  data() {
    return {
      list: [],
      selectList: [],
      selectedIds: [],
      selectGroupIds: [],
      originData: [],
      customTreeList: []
    };
  },
  methods: {
    saveDialog() {
      this.$emit('change', this.selectList);
    }
  }
};
</script>

<style>
@import './dislogStyle/dialog.css';
</style>
